import { getCssVar } from "../../types/theme.ts";

export const RedX = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="remove 1" clipPath="url(#clip0_3736_2622)">
      <path
        id="Vector"
        d="M12 24.188C5.38293 24.188 0 18.8051 0 12.188C0 5.57092 5.38293 0.187988 12 0.187988C18.6171 0.187988 24 5.57092 24 12.188C24 18.8051 18.6171 24.188 12 24.188ZM12 1.68799C6.21002 1.68799 1.5 6.39801 1.5 12.188C1.5 17.978 6.21002 22.688 12 22.688C17.79 22.688 22.5 17.978 22.5 12.188C22.5 6.39801 17.79 1.68799 12 1.68799Z"
        fill={getCssVar("color_remove_icon")}
      />
      <path
        id="Vector_2"
        d="M8.28809 16.6498C8.09601 16.6498 7.90393 16.5769 7.758 16.4299C7.46503 16.1369 7.46503 15.6619 7.758 15.369L15.1829 7.94385C15.4761 7.65088 15.951 7.65088 16.244 7.94385C16.537 8.23682 16.537 8.71179 16.244 9.00494L8.81891 16.4299C8.67096 16.5769 8.47906 16.6498 8.28809 16.6498Z"
        fill={getCssVar("color_remove_icon")}
      />
      <path
        id="Vector_3"
        d="M15.7119 16.6498C15.52 16.6498 15.328 16.5769 15.182 16.4299L7.7571 9.00587C7.46394 8.71291 7.46394 8.23793 7.7571 7.94496C8.05006 7.65181 8.52504 7.65181 8.81801 7.94496L16.2429 15.3699C16.5361 15.6629 16.5361 16.1378 16.2429 16.4308C16.0961 16.5769 15.904 16.6498 15.7119 16.6498Z"
        fill={getCssVar("color_remove_icon")}
      />
    </g>
    <defs>
      <clipPath id="clip0_3736_2622">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.187988)"
        />
      </clipPath>
    </defs>
  </svg>
);
